import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function CountrySkeleton() {
    return <Skeleton height={700} />;
}
